import { get } from '../http';

export const getAll = () => get('v2/Countries');
